import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { apiService } from "../../services/apiService";

export const fetchLaundryDisputed = createAsyncThunk(
  "laundryDisputed/fetchLaundryDisputed",
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const response = await apiService.get("/disputed", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const laundryDisputedSlice = createSlice({
  name: "laundryDisputed",
  initialState: {
    laundryDisputeds: [],
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchLaundryDisputed.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchLaundryDisputed.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.laundryDisputeds = action.payload.data;
      })
      .addCase(fetchLaundryDisputed.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export default laundryDisputedSlice.reducer;
